export default {
  name: 'account',
  methods: {
    /**
     * Fetch user account information
     */
    async getUser(feature = 'release') {
      const { data } = await window.axios.get(`/api/client/users/${this.$store.state.auth.id}`)
      this.userData = data
      /* eslint-disable camelcase */
      const {
        id,
        bank_code,
        bank_name,
        bank_branch_code,
        bank_branch_name,
        bank_account_type,
        bank_account_code,
        bank_account_name,
        prefecture,
        address1,
        address2,
        contact_name,
        postal_code,
      } = this.userData.company
      const { dob } = this.userData
      /* eslint-enable camelcase */
      window.sessionStorage.setItem('account_information', JSON.stringify({
        id,
        bank_code,
        bank_name,
        bank_branch_name,
        bank_branch_code,
        bank_account_type,
        bank_account_code,
        bank_account_name,
        prefecture,
        address1,
        address2,
        contact_name,
        dob,
        postal_code,
        feature,
      }))
      return this.userData
    },
    /**
     * Checks whether required user account information exists or not
     */
    checkIfUserDataAvailable(userData) {
      if (!userData) return false
      const requiredFields = [
        'address1',
        'bank_name',
        'bank_account_code',
        'bank_account_name',
        'bank_branch_name',
        'bank_account_type',
        'contact_name',
        'postal_code',
        'prefecture',
      ]

      return requiredFields.every(field => !!userData.company[field])
        && userData.dob !== null
    },
  },
}
